import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { Router } from '@angular/router';
import { Signup } from '../interfaces/signup.interface';
import { SignupService } from '../services/signup.service';
import { environment } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import {
  HttpErrorHandlerService,
  MessageType,
} from 'src/app/shared-resources/services/http-error-handling.service';
import { Validations } from 'src/app/shared-resources/constants/validations.constant';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.less'],
})
export class SignupComponent implements OnInit {
  public validateForm: FormGroup;
  public passwordVisible = false;
  public password: string;
  public loading = false;
  public listAreaofInterest: any[] = [];
  public listOfSelectedAOIValue: string[] = [];
  public recaptchaEnable: boolean = environment.recaptchaEnable;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private signupService: SignupService,
    private translate: TranslateService,
    private httpMessage: HttpErrorHandlerService
  ) {}

  ngOnInit(): void {
    const a = [{ key: 'area.of.interest', value: this.listAreaofInterest }];
    for (const _a of a) {
      this.signupService.getPublicLOVs(_a.key)?.subscribe((val) => {
        const label = this.signupService.manipulateData(val);
        label.forEach((value: any) => {
          _a.value.push(value);
        });
      });
    }

    this.validateForm = this.fb.group(
      {
        userName: [
          null,
          [Validators.required, Validators.pattern(Validations.REGEX_USERNAME)],
        ],
        firstName: [null, [Validators.required]],
        lastName: [null, [Validators.required]],
        email: [
          null,
          [Validators.required, Validators.pattern(Validations.REGEX_EMAIL)],
        ],
        remember: [true],
        areaofinterest: [null, [Validators.required]],
        recaptchaReactive: [null],
        password: [null, Validators.compose([Validators.required])],
        cpassword: [null, Validators.compose([Validators.required])],
      },
      {
        validators: this.passwordMatchValidator,
      }
    );

    this.setCaptchaEnable();
  }

  setCaptchaEnable(): void {
    if (this.recaptchaEnable === true) {
      this.validateForm.controls['recaptchaReactive'].setValidators([
        Validators.required,
      ]);
      this.validateForm.controls['recaptchaReactive'].updateValueAndValidity();
    } else {
      this.validateForm.controls['recaptchaReactive'].clearValidators();
      this.validateForm.controls['recaptchaReactive'].updateValueAndValidity();
    }
  }

  submitForm(): void {
    for (const i in this.validateForm.controls) {
      if (i) {
        this.validateForm.controls[i].markAsDirty();
        this.validateForm.controls[i].updateValueAndValidity();
      }
    }
  }

  signin(): void {
    this.router.navigateByUrl('/login');
  }

  signup(): void {
    this.loading = true;
    if (this.validateForm.valid) {
      const signupBody: Signup = {
        userName: this.validateForm.controls['userName'].value,
        firstName: this.validateForm.controls['firstName'].value,
        lastName: this.validateForm.controls['lastName'].value,
        password: this.validateForm.controls['password'].value,
        email: this.validateForm.controls['email'].value,
        areaOfInterest: this.validateForm.controls['areaofinterest'].value,
        blk: true,
        address: '',
        phoneNumber: '',
        gender: 'M',
        lang: 'en',
      };
      this.signupService.signup(signupBody)?.subscribe(
        () => {
          this.httpMessage.showTopFloatMessage(
            this.translate.instant('app.signup.success.description'),
            MessageType.SUCCESS,
            this.translate.instant('app.signup.success.title')
          );
          this.loading = false;
          this.validateForm.reset();
          this.listOfSelectedAOIValue = [];
        },
        (error) => {
          this.httpMessage.showTopFloatMessage(
            error.error,
            MessageType.ERROR,
            this.translate.instant('app.signup.failed.title')
          );
          this.loading = false;
        }
      );
    } else {
      this.loading = false;
    }
  }

  patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: string } | null => {
      if (!control.value) {
        return null;
      }
      const valid = regex.test(control.value);
      return valid ? null : error;
    };
  }

  passwordMatchValidator(control: AbstractControl): void {
    const password: string = control.get('password')?.value
      ? control.get('password')?.value
      : null;
    const confirmPassword: string = control.get('cpassword')?.value;
    if (password !== confirmPassword) {
      control.get('cpassword')?.setErrors({ NoPassswordMatch: true });
    }
  }
}
